import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { LicenseInfo } from '@mui/x-license';
import AuthProvider from 'api/providers/authProvider';
import WorkspaceProvider from 'api/providers/workspaceProvider';
import ClipboardUI from 'components/ClipboardUI';
import Header from 'components/header';
import ModalProvider from 'components/modal';
import NotificationProvider from 'components/notify';
import RootEntityTypePage from 'components/rootEntityTypePage';
import { AccountPage } from 'pages/account';
import AutomationsPage from 'pages/automations';
import ComingUp from 'pages/comingUp';
import DatamaidPage from 'pages/datamaid';
import FieldEditorPage from 'pages/fieldEditor/fieldEditorPage';
import FieldEditorFieldsPage from 'pages/fieldEditor/fieldsPage';
import FieldEditorTypesPage from 'pages/fieldEditor/typePage';
import FilesPage from 'pages/files';
import FileThingPage from 'pages/fileThingy';
import FinsightEntityPage from 'pages/finsightEntity';
import Home from 'pages/home';
import { FieldJSONGeneratorPage } from 'pages/jsonGenerator';
import LoginPage from 'pages/login';
import PluginsPage from 'pages/plugins';
import RootEntitiesPage from 'pages/rootEntities';
import ScratchpadPage from 'pages/scratchpad';
import { Providers } from 'providers';
import React from 'react';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { darkTheme, lightTheme } from 'theme';

LicenseInfo.setLicenseKey(
  '05a2ce020d90053b6547efbd692fa010Tz1NaWNyb2FydCxFPTI3MjA5MjA2ODUzMjUsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y',
);

function App() {
  const darkMode = true;
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <CssBaseline />

        <BrowserRouter>
          <Routes>
            <Route
              element={
                <AuthProvider>
                  <Outlet />
                </AuthProvider>
              }
            >
              <Route path="/login" element={<LoginPage />} />
              <Route
                element={
                  <NotificationProvider>
                    <WorkspaceProvider>
                      <Providers>
                        <ModalProvider>
                          <Header>
                            <Outlet />
                          </Header>
                          <ClipboardUI />
                        </ModalProvider>
                      </Providers>
                    </WorkspaceProvider>
                  </NotificationProvider>
                }
              >
                <Route path="" element={<Home />} />
                <Route path="/coming-up" element={<ComingUp />} />
                <Route path="/workspace/:workspaceId">
                  <Route path="" element={<Home />} />
                  <Route path="*" element={<span>404</span>} />
                  <Route
                    path="groups"
                    element={<RootEntityTypePage key="group" type="group" />}
                  />
                  <Route
                    path="items"
                    element={<RootEntityTypePage key="item" type="item" />}
                  />
                  <Route path="entities" element={<RootEntitiesPage />} />
                  <Route
                    path="projects"
                    element={
                      <RootEntityTypePage key="project" type="project" />
                    }
                  />
                  <Route
                    path="tasks"
                    element={<RootEntityTypePage key="task" type="task" />}
                  />
                  <Route path="coming-up" element={<ComingUp />} />
                  <Route path="entity/:id" element={<FinsightEntityPage />} />
                  <Route path="scratchpad" element={<ScratchpadPage />} />
                  <Route
                    path="field-editor"
                    element={<FieldEditorTypesPage />}
                  />
                  <Route
                    path="json-generator"
                    element={<FieldJSONGeneratorPage />}
                  />
                  <Route
                    path="field-editor/:fieldType"
                    element={<FieldEditorFieldsPage />}
                  />
                  <Route
                    path="field-editor/:fieldType/:fieldName"
                    element={<FieldEditorPage />}
                  />
                  <Route path="scratchpad/:id" element={<ScratchpadPage />} />
                  <Route path="files" element={<FilesPage />} />
                  <Route path="datamaid" element={<DatamaidPage />} />
                  <Route path="file-thingy" element={<FileThingPage />} />
                  <Route path="automations" element={<AutomationsPage />} />
                  <Route path="plugins" element={<PluginsPage />} />
                </Route>
                <Route path="/account" element={<AccountPage />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
